import { Component } from '@ecs/Component';

export type ColliderGroup = 'player' | 'enemy' | 'playerBullet' | 'enemyBullet' | 'particle' | 'pointDefenseBullet';

export class Collider implements Component {
  readonly type = 'Collider';

  constructor(
    public radius: number,
    public group: ColliderGroup,
    public collidesWith: ColliderGroup[] = []
  ) {}
}